import Vue from "vue";

export const state = {
    options: {
        title: "",
        content: "",
        resolve: null
    }
};

export const getters = {
    dialog: ({ options }) => options
};

export const actions = {
    UPDATE_DIALOG({ commit }, options) {
        const rNumber = Math.random();
        const rString = rNumber.toString().slice(2, 8);
        options.id = `d-${rString}`;
        if (options.dismissible === undefined) options.dismissible = false;
        const promise = new Promise(resolve => {
            options.resolve = resolve;
        });
        commit("SET_DIALOG", options);
        return promise;
    }
};

export const mutations = {
    SET_DIALOG(state, options) {
        Vue.set(state, "options", options);
    },
    UPDATE_DIALOG_OPTION(state, value) {
        Vue.set(state, "options", { ...state.options, ...value });
    },
    UPDATE_DIALOG_ACTION({ options: { actions = [] } }, value) {
        const index = actions.findIndex(
            ({ action }) => action === value.action
        );
        if (index !== -1) actions.splice(index, 1, value);
    },
    RESOLVE_DIALOG({ options: { resolve } }, result) {
        if (typeof resolve === "function") resolve(result);
        Vue.set(state, "options", {});
    }
};
